import React from 'react'
import {ExitIcon} from "components/Icons";
import { Link } from "react-router-dom";
import cn from 'classnames'
import StyledMenuButtons from 'components/styled/MenuButtons.styled';


const MenuButtons = ({isMenuOpen, setIsMenuOpen, showExitButton=true}) => {
  return (
    <StyledMenuButtons className="menu-buttons">
    <button className="button button-menu" onClick={(e) => {e.stopPropagation(); setIsMenuOpen(prev => !prev)}}>
      <div className={cn('icon hamburger', {'is-active': isMenuOpen})}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
      <div className="text">{ !isMenuOpen ? 'Menu' : 'Close'}</div>
    </button>
   {showExitButton && (
      <Link to="/" className="button button-exit">
      <div className="icon">
        <ExitIcon color="#595959" />
      </div>
      <div className="text">Home</div>
    </Link>
   )}
  </StyledMenuButtons>
  )
}

export default MenuButtons